// src/pages/SetupSuppliersCustomers.js

import React, { useEffect, useState } from "react";
import {
  Card, Table, Button, DatePicker,Modal, Form, Input, Tabs, Space,Upload, message, Popconfirm,InputNumber , Row, Col, Select} from "antd";
import { UploadOutlined, EditOutlined, DeleteOutlined, PlusOutlined ,DownloadOutlined} from "@ant-design/icons";
import api from '../api/axios'; // Adjust the path as needed
import moment from "moment";


const { TabPane } = Tabs;

export default function SetupSuppliersCustomers() {

  // Suppliers
  const [suppliers, setSuppliers] = useState([]);
  const [supplierModalVisible, setSupplierModalVisible] = useState(false);
  const [supplierForm] = Form.useForm();
  const [editingSupplier, setEditingSupplier] = useState(null);

  // Customers
  const [customers, setCustomers] = useState([]);
  const [customerModalVisible, setCustomerModalVisible] = useState(false);
  const [customerForm] = Form.useForm();
  const [editingCustomer, setEditingCustomer] = useState(null);

// PO Master
const [po, setPO] = useState([]);
const [poModalVisible, setPOModalVisible] = useState(false);
const [poForm] = Form.useForm();
const [editingPO, setEditingPO] = useState(null);
//for onChage of PO_reminaing amount
    const [oldPOAmount, setOldPOAmount] = useState(0);
    const [oldRemainingPO, setOldRemainingPO] = useState(0);

// SAC Code
const [sacCodes, setSacCodes] = useState([]);
const [sacModalVisible, setSacModalVisible] = useState(false);
const [editingSac, setEditingSac] = useState(null);
const [sacForm] = Form.useForm();

// State for billers and modal visibility
    const [billers, setBillers] = useState([]);
    const [billerModalVisible, setBillerModalVisible] = useState(false);
    const [editingBiller, setEditingBiller] = useState(null);
    const [billerForm] = Form.useForm();

// State for adhoc list
    const [adhocs, setAdhocs] = useState([]);
    const [adhocLoading, setAdhocLoading] = useState(false);
    const [adhocModalVisible, setAdhocModalVisible] = useState(false);
    const [editingAdhoc, setEditingAdhoc] = useState(null);
    const [adhocForm] = Form.useForm();
    const [adhocCsvFileList, setAdhocCsvFileList] = useState([]);


// Supplier Filters
const [supplierLocationFilter, setSupplierLocationFilter] = useState([]);
const [supplierNameFilter, setSupplierNameFilter] = useState([]);


// Customer Filters
const [customerLocationFilter, setCustomerLocationFilter] = useState([]);
const [customerNameFilter, setCustomerNameFilter] = useState([]);

// Filter customers according to selected filters  cascaded filter
const filteredCustomersList = customers.filter(c =>
        (customerNameFilter.length === 0 || customerNameFilter.includes(c.CustomerName)) &&
        (customerLocationFilter.length === 0 || customerLocationFilter.includes(c.Location))
    );

   // PO Filters
const [poNumberFilter, setPONumberFilter] = useState([]);
const [poLocationFilter, setSPOLocationFilter] = useState([]);
const [poCustomerNameFilter, setPOCustomerNameFilter] = useState([]);


  // Fetch data
  useEffect(() => {
    fetchSuppliers();
    fetchCustomers();
    fetchPO();
    fetchSacCodes();
    fetchBillers();
  }, []);

  const fetchSuppliers = () => {
    api.get("/suppliers").then(res => setSuppliers(res.data));
  };
  const fetchCustomers = () => {
    api.get("/customers").then(res => setCustomers(res.data));
  };
  const fetchPO = () => {
    api.get("/pomaster").then(res => setPO(res.data));
  };
    const fetchSacCodes = () => {
        api.get('/saccode').then(res => {
            setSacCodes(Array.isArray(res.data) ? res.data : []);
        }).catch(() => {
            setSacCodes([]);  // fallback to empty array if error
        });
    };
    const fetchBillers = () => {
        api.get('/biller').then(res => setBillers(res.data));
    };

    // biller  fields
    const onBillerFinish = values => {
        if (editingBiller) {
            api.put(`/biller/${editingBiller.id}`, values).then(() => {
                message.success('Biller updated');
                setBillerModalVisible(false);
                billerForm.resetFields();
                setEditingBiller(null);
                fetchBillers();
            });
        } else {
            api.post('/biller', values).then(() => {
                message.success('Biller added');
                setBillerModalVisible(false);
                billerForm.resetFields();
                fetchBillers();
            });
        }
    };



    const onPOFinish = (values) => {
    // Find customer from ID
    const cust = customers.find(c => c.CustomerID === values.CustomerID) || {};
    const payload = {
      ...values,
      CustomerName: cust.CustomerName,
      Location: cust.Location,
      PO_Date: values.PO_Date.format("YYYY-MM-DD"),
    };
    if (editingPO) {
      api.put(`/pomaster/${editingPO.POID}`, payload).then(() => {
        message.success("PO updated!");
        setPOModalVisible(false);
        poForm.resetFields();
        setEditingPO(null);
        fetchPO();
      });
    } else {
      api.post("/pomaster", payload).then(() => {
        message.success("PO added!");
        setPOModalVisible(false);
        poForm.resetFields();
        fetchPO();
      });
    }
  };

  const handlePOCSV = ({ file }) => {
    const formData = new FormData();
    formData.append("file", file);
    api.post("/pomaster/import", formData).then(() => {
      message.success("POs imported!");
      fetchPO();
    }).catch(() => {
      message.error("Failed to import POs. Please check your CSV format.");
    });
  };

  const handleEditPO = (record) => {
    setEditingPO(record);
      // Set old PO and Remaining values here from record
      setOldPOAmount(record.PO_Amount);
      setOldRemainingPO(record.PO_Remaining_Amount);

    poForm.setFieldsValue({
      ...record,
      PO_Date: moment(record.PO_Date),
      CustomerID: record.CustomerID, // Preselect customer in dropdown
    });
    setPOModalVisible(true);
  };

    // Handler for PO Amount change - updates Remaining amount live
    const onPOAmountChange = (newPOAmount) => {
        const newRemaining = newPOAmount - oldPOAmount + oldRemainingPO;
        poForm.setFieldsValue({ PO_Remaining_Amount: newRemaining});
        setOldRemainingPO(newRemaining);
        setOldPOAmount(newPOAmount);
    };


const handleDeletePO = (POID) => {
    api.delete(`/pomaster/${POID}`).then(() => {
      message.success("PO deleted!");
      fetchPO();
    });
  };

  // Add/Edit Supplier
  const onSupplierFinish = (values) => {
    if (editingSupplier) {
      api.put(`/suppliers/${editingSupplier.SupplierID}`, values).then(() => {
        message.success("Supplier updated!");
        setSupplierModalVisible(false);
        supplierForm.resetFields();
        setEditingSupplier(null);
        fetchSuppliers();
      });
    } else {
      api.post("/suppliers", values).then(() => {
        message.success("Supplier added!");
        setSupplierModalVisible(false);
        supplierForm.resetFields();
        fetchSuppliers();
      });
    }
  };


  // filters
    const supplierLocationOptions = [...new Set(suppliers.map(s => s.Location).filter(Boolean))];
    const supplierNameOptions = [...new Set(suppliers.map(s => s.SupplierName).filter(Boolean))];

    // Compute dynamic options for filter dropdowns from the filtered list
    const customerNameOptions = [...new Set(filteredCustomersList.map(c => c.CustomerName).filter(Boolean))];
    const customerLocationOptions = [...new Set(filteredCustomersList.map(c => c.Location).filter(Boolean))];

    const poNumberOptions = [...new Set(po.map(po => po.PO_Number).filter(Boolean))];
    const poCustomerNameOptions = [...new Set(po.map(po => po.CustomerName).filter(Boolean))];
    const poLocationOptions = [...new Set(po.map(po => po.Location).filter(Boolean))];

    const filteredCustomers = customers.filter(c =>
        (customerLocationFilter.length === 0 || customerLocationFilter.includes(c.Location)) &&
        (customerNameFilter.length === 0 || customerNameFilter.includes(c.CustomerName))
    );
    const filteredSuppliers = suppliers.filter(c =>
        (supplierLocationFilter.length === 0 || supplierLocationFilter.includes(c.Location)) &&
        (supplierNameFilter.length === 0 || supplierNameFilter.includes(c.SuppliersName))
    );
    const filteredPO = po.filter(c =>
        (poNumberFilter.length === 0 || poNumberFilter.includes(c.PO_Number)) &&
        (poLocationFilter.length === 0 || poLocationFilter.includes(c.Location)) &&
        (poCustomerNameFilter.length === 0 || poCustomerNameFilter.includes(c.CustomerName))
    );

    // Add/Edit Customer
  const onCustomerFinish = (values) => {
    if (editingCustomer) {
      api.put(`/customers/${editingCustomer.CustomerID}`, values).then(() => {
        message.success("Customer updated!");
        setCustomerModalVisible(false);
        customerForm.resetFields();
        setEditingCustomer(null);
        fetchCustomers();
      });
    } else {
      api.post("/customers", values).then(() => {
        message.success("Customer added!");
        setCustomerModalVisible(false);
        customerForm.resetFields();
        fetchCustomers();
      });
    }
  };

  // CSV Import Supplier
  const handleSupplierCSV = ({ file }) => {
    const formData = new FormData();
    formData.append("file", file);
    api.post("/suppliers/import", formData).then(() => {
      message.success("Suppliers imported!");
      fetchSuppliers();
    }).catch(() => {
      message.error("Failed to import suppliers. Please check your CSV format.");
    });
  };

  // CSV Import Customer
  const handleCustomerCSV = ({ file }) => {
    const formData = new FormData();
    formData.append("file", file);
    api.post("/customers/import", formData).then(() => {
      message.success("Customers imported!");
      fetchCustomers();
    }).catch(() => {
      message.error("Failed to import customers. Please check your CSV format.");
    });
  };

  // Edit Supplier
  const handleEditSupplier = (record) => {
    setEditingSupplier(record);
    supplierForm.setFieldsValue(record);
    setSupplierModalVisible(true);
  };

  // Delete Supplier
  const handleDeleteSupplier = (id) => {
    api.delete(`/suppliers/${id}`).then(() => {
      message.success("Supplier deleted!");
      fetchSuppliers();
    });
  };

  // Edit Customer
  const handleEditCustomer = (record) => {
    setEditingCustomer(record);
    customerForm.setFieldsValue(record);
    setCustomerModalVisible(true);
  };

  // Delete Customer
  const handleDeleteCustomer = (id) => {
    api.delete(`/customers/${id}`).then(() => {
      message.success("Customer deleted!");
      fetchCustomers();
    });
  };

  // handlers for SAC_code
    const handleEditSac = (record) => {
        setEditingSac(record);
        sacForm.setFieldsValue(record);
        setSacModalVisible(true);
    };
    const handleDeleteSac = (sacID) => {
        api.delete(`/saccode/${sacID}`).then(() => {
            message.success("SAC Code deleted");
            fetchSacCodes();
        });
    };
    const onSacFinish = (values) => {
        if (editingSac) {
            api.put(`/saccode/${editingSac.sacID}`, values).then(() => {
                message.success("SAC Code updated");
                setSacModalVisible(false);
                sacForm.resetFields();
                setEditingSac(null);
                fetchSacCodes();
            });
        } else {
            api.post('/saccode', values).then(() => {
                message.success("SAC Code added");
                setSacModalVisible(false);
                sacForm.resetFields();
                fetchSacCodes();
            });
        }
    };


    const supplierColumns = [
    { title: "Name", dataIndex: "SupplierName" },
    { title: "Supplier Address", dataIndex: "SupplierAddress" },
    { title: "GST", dataIndex: "GST" },
    { title: "PAN", dataIndex: "PAN" },
    { title: "Bank Name", dataIndex: "BankName" },
    { title: "Bank Account", dataIndex: "BankAccount" },
    { title: "IFSC Code", dataIndex: "IFSC" },
    { title: "TAN", dataIndex: "TAN" },
    { title: "Location", dataIndex: "Location" },
    { title: "Contact", dataIndex: "Contact" },
    { title: "Email", dataIndex: "Email" },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) => (
        <>
          <Button icon={<EditOutlined />} onClick={() => handleEditSupplier(record)} style={{ marginRight: 8 }} />
          <Popconfirm
            title="Delete this supplier?"
            onConfirm={() => handleDeleteSupplier(record.SupplierID)}
            okText="Yes"
            cancelText="No"
          >
            <Button icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </>
      )
    }
  ];

  const poColumns = [
  { title: "PO Number", dataIndex: "PO_Number" },
  { title: "PO Date", dataIndex: "PO_Date" },
  { title: "PO Description", dataIndex: "PO_Desc" },
   { title: "Customer", dataIndex: "CustomerName" },
   { title: "Location", dataIndex: "Location" },
  { title: "PO Amount", dataIndex: "PO_Amount" },
  { title: "PO Remaining Amount", dataIndex: "PO_Remaining_Amount" },
  {
    title: "Actions",
    dataIndex: "actions",
    render: (_, record) => (
      <>
        <Button icon={<EditOutlined />} onClick={() => handleEditPO(record)} style={{ marginRight: 8 }} />
        <Popconfirm
          title="Delete this PO?"
          onConfirm={() => handleDeletePO(record.POID)}
          okText="Yes"
          cancelText="No"
        >
          <Button icon={<DeleteOutlined />} danger />
        </Popconfirm>
      </>
    )
  }
];

  const customerColumns = [
    { title: "Customer ID", dataIndex: "CustomerID" },
    { title: "Name", dataIndex: "CustomerName" },
    { title: "Location", dataIndex: "Location" },
    { title: "Customer Address", dataIndex: "CustomerAddress" },
    { title: "GST", dataIndex: "GST" },
    { title: "PAN", dataIndex: "PAN" },
    { title: "Contact", dataIndex: "Contact" },
    { title: "Email", dataIndex: "Email" },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) => (
        <>
          <Button icon={<EditOutlined />} onClick={() => handleEditCustomer(record)} style={{ marginRight: 8 }} />
          <Popconfirm
            title="Delete this customer?"
            onConfirm={() => handleDeleteCustomer(record.CustomerID)}
            okText="Yes"
            cancelText="No"
          >
            <Button icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </>
      )
    }
  ];

    const sacColumns = [
        {
            title: "SAC Code",
            dataIndex: "SAC_Code",
            sorter: (a, b) => (a.SAC_Code || "").localeCompare(b.SAC_Code || "")
        },
        {
            title: "GST Value (%)",
            dataIndex: "GST_Value",
            sorter: (a, b) => (a.GST_Value || 0) - (b.GST_Value || 0)
        },
        {
            title: "Actions",
            dataIndex: "actions",
            render: (_, record) => (
                <>
                    <Button icon={<EditOutlined />} onClick={() => handleEditSac(record)} style={{ marginRight: 8 }} />
                    <Popconfirm
                        title="Sure to delete?"
                        onConfirm={() => handleDeleteSac(record.sacID)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button danger>Delete</Button>
                    </Popconfirm>
                </>
            )
        }
    ];

    const billerColumns = [
        { title: 'Company Name', dataIndex: 'company_name' },
        { title: 'Address', dataIndex: 'Address' },
        { title: 'Account Holder', dataIndex: 'account_holder' },
        { title: 'Bank Name', dataIndex: 'bank_name' },
        { title: 'TAN', dataIndex: 'TAN' },
        { title: 'Account Number', dataIndex: 'Account_number' },
        { title: 'IFSC Code', dataIndex: 'IFSC_code' },
        { title: 'GST Number', dataIndex: 'GST' },
        { title: 'Email', dataIndex: 'email' },
        { title: 'Mobile', dataIndex: 'Mobile' },
        { title: 'Vendor Code', dataIndex: 'Vendor_code' },
        { title: 'PAN', dataIndex: 'PAN' },

        {
            title: 'Actions',
            render: (_, record) => (
                <>
                    <Button
                        type="link"
                        onClick={() => {
                            setEditingBiller(record);
                            billerForm.setFieldsValue(record);
                            setBillerModalVisible(true);
                        }}
                    >
                        Edit
                    </Button>
                    <Popconfirm
                        title="Sure to delete?"
                        onConfirm={() => {
                            api.delete(`/biller/${record.id}`).then(() => {
                                message.success('Biller deleted');
                                fetchBillers();
                            });
                        }}
                    >
                        <Button type="link" danger>
                            Delete
                        </Button>
                    </Popconfirm>
                </>
            )
        }
    ];

    // adhocList columns:
    const adhocColumns = [
        { title: 'ID', dataIndex: 'id', key: 'id', width: 80 },
        { title: 'Name', dataIndex: 'Name', key: 'Name' },
        { title: 'Message', dataIndex: 'Message', key: 'Message', ellipsis: true },
        {
            title: 'Amount',
            dataIndex: 'Amount',
            key: 'Amount',
            render: (amt) => `₹${Number(amt).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`
        },
        { title: 'Contact', dataIndex: 'Contact', key: 'Contact' },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <Space size="small">
                    <Button
                        icon={<EditOutlined />}
                        size="small"
                        onClick={() => {
                            setEditingAdhoc(record);
                            adhocForm.setFieldsValue(record);
                            setAdhocModalVisible(true);
                        }}
                    />
                    <Popconfirm
                        title="Delete record?"
                        onConfirm={() => deleteAdhoc(record.id)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button icon={<DeleteOutlined />} size="small" danger />
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    // handlers for adhocList

    const fetchAdhocs = async () => {
        setAdhocLoading(true);
        try {
            const response = await api.get('/adhoclist/list');
            setAdhocs(response.data);
        } catch (error) {
            message.error('Failed to fetch adhoc list');
        }
        setAdhocLoading(false);
    };

    const onAdhocFinish = async (values) => {
        try {
            if (editingAdhoc) {
                await api.put(`/adhoclist/edit/${editingAdhoc.id}`, values);
                message.success('Record updated');
            } else {
                await api.post('/adhoclist/add', values);
                message.success('Record added');
            }
            setAdhocModalVisible(false);
            adhocForm.resetFields();
            setEditingAdhoc(null);
            fetchAdhocs();
        } catch (error) {
            message.error(error.response?.data?.error || 'Operation failed');
        }
    };

    const deleteAdhoc = async (id) => {
        try {
            await api.delete(`/adhoclist/delete/${id}`);
            message.success('Record deleted');
            fetchAdhocs();
        } catch (error) {
            message.error('Failed to delete record');
        }
    };

// CSV Upload props
    const adhocCsvUploadProps = {
        name: 'file',
        multiple: false,
        accept: '.csv',
        showUploadList: false,
        fileList: adhocCsvFileList,
        beforeUpload: async (file) => {
            const formData = new FormData();
            formData.append('file', file);
            try {
                const response = await api.post('/adhoclist/bulk', formData);
                message.success(`Bulk import: ${response.data.success || 0} success, ${response.data.failed || 0} failed`);
                fetchAdhocs();
            } catch (error) {
                message.error(error.response?.data?.error || 'Bulk import failed');
            }
            return false;
        },
        onChange: ({ fileList }) => setAdhocCsvFileList(fileList),
    };

// Sample CSV download
    const downloadSampleCsv = () => {
        const csvContent = `Name,Message,Amount,Contact
Test User,Payment reminder,5000.00,9876543210
Test User 2,Invoice due,2500.50,9876543211`;

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'adhoc-sample.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

// Load data on mount
    useEffect(() => {
        fetchAdhocs();
    }, []);

 // adhoc list ends




    //  export to csv functions
    // --- CSV Export Helper ---
    // --- Pipe-delimited CSV Export Helper ---
    const exportCSV = (data, filename) => {
        if (!data || data.length === 0) {
            message.warning("No data to export!");
            return;
        }

        // Use pipe '|' as delimiter
        const delimiter = '|';

        // Convert object array to CSV string
        const headers = Object.keys(data[0]).join(delimiter);
        const rows = data.map(row =>
            Object.values(row)
                .map(val =>
                    val === null || val === undefined
                        ? ''
                        : `"${String(val).replace(/"/g, '""')}"`
                )
                .join(delimiter)
        );
        const csvString = [headers, ...rows].join('\r\n');

        // Create a downloadable link
        const blob = new Blob([csvString], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${filename}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };




    return (
    <Card title="Setup Suppliers and Customers">
      <Tabs defaultActiveKey="suppliers">
        <TabPane tab="Suppliers" key="suppliers">
          <div style={{ marginBottom: 16 }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                setSupplierModalVisible(true);
                setEditingSupplier(null);
                supplierForm.resetFields();
              }}
            >
              Add Supplier
            </Button>
            <Upload
              accept=".csv"
              showUploadList={false}
              customRequest={handleSupplierCSV}
              style={{ marginLeft: 8 }}
            >
              <Button icon={<UploadOutlined />} style={{ marginLeft: 8 }}>
                Import Suppliers CSV
              </Button>
            </Upload>
            <Button
                  type="default"
                  onClick={() => exportCSV(filteredCustomersList, "Customers")}
                  style={{ marginLeft: 8 }}
              >
                  Export Customers CSV
            </Button>

              <a
              href="/suppliers_sample.csv"
              download
              style={{ marginLeft: 16 }}
            >
              Download Sample CSV
            </a>
          </div>
            <Row gutter={8} style={{ marginBottom: 8 }}>
                <Col>
                    <Select
                        mode="multiple"
                        style={{ minWidth: 400 }}
                        allowClear
                        placeholder="Filter by Supplier Name"
                        value={supplierNameFilter}
                        onChange={setSupplierNameFilter}
                    >
                        {supplierNameOptions.map(loc => (
                            <Select.Option key={loc} value={loc}>{loc}</Select.Option>
                        ))}
                    </Select>
                </Col>
                <Col>
                    <Select
                        mode="multiple"
                        style={{ minWidth: 140 }}
                        allowClear
                        placeholder="Filter by Location"
                        value={supplierLocationFilter}
                        onChange={setSupplierLocationFilter}
                    >
                        {supplierLocationOptions.map(loc => (
                            <Select.Option key={loc} value={loc}>{loc}</Select.Option>
                        ))}
                    </Select>
                </Col>

                <Col>
                    <Button onClick={() => { setSupplierLocationFilter([]);setSupplierNameFilter([]); }}>Reset</Button>
                </Col>
            </Row>

            <Table
            dataSource={filteredSuppliers}
            columns={supplierColumns}
            rowKey="SupplierID"
            scroll={{ x: 1000 }}
          />
          <Modal
            open={supplierModalVisible}
            onCancel={() => {
              setSupplierModalVisible(false);
              setEditingSupplier(null);
              supplierForm.resetFields();
            }}
            onOk={() => supplierForm.submit()}
            title={editingSupplier ? "Edit Supplier" : "Add Supplier"}
            destroyOnClose
            width={800}
          >
            <Form form={supplierForm} onFinish={onSupplierFinish} layout="vertical">
              <Form.Item name="SupplierName" label="Supplier Name" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item name="SupplierAddress" label="Supplier Address">
                <Input.TextArea rows={2} />
              </Form.Item>
              <Form.Item
                  name="GST"
                  label="GST"
                  rules={[
                    //{ required: true, message: "GST is required." },
                    {
                      pattern: /^[A-Za-z0-9]{15}$/,
                      message: "GST must be exactly 15 alphanumeric characters (no special characters)."
                    }
                  ]}
              >
                <Input maxLength={15} />
              </Form.Item>
                <Form.Item
                    name="PAN"
                    label="PAN Number"
                    rules={[
                        {
                            validator: (_, value) => {
                                const gstValue = supplierForm.getFieldValue('GST');
                                if ((gstValue == null || gstValue === 0) &&
                                    (value === "Nil" || value?.toLowerCase() === "nil" || !value)) {
                                    return Promise.resolve();
                                }

                                if (!value) {
                                    return Promise.reject(new Error("PAN is required"));
                                }
                                // Add other PAN format validations here if needed
                                return Promise.resolve();
                            }
                        }
                    ]}
                >
                    <Input placeholder="Enter PAN or 'Nil' if GST is 0" />
                </Form.Item>
                <Form.Item
                    name="TAN"
                    label="TAN Number"
                    rules={[
                        {
                            validator: (_, value) => {
                                const gstValue = supplierForm.getFieldValue('GST');
                                if ((gstValue == null || gstValue === 0) &&
                                    (value === "Nil" || value?.toLowerCase() === "nil" || !value)) {
                                    return Promise.resolve();
                                }
                                if (!value) {
                                    return Promise.reject(new Error("TAN is required"));
                                }
                                // Add other TAN format validations here if needed
                                return Promise.resolve();
                            }
                        }
                    ]}
                >
                    <Input placeholder="Enter TAN or 'Nil' if GST is 0" />
                </Form.Item>
              <Form.Item name="BankName" label="Bank Name"><Input /></Form.Item>
              <Form.Item name="BankAccount" label="Bank Account"><Input /></Form.Item>
              <Form.Item name="IFSC" label="IFSC Code"><Input /></Form.Item>
              <Form.Item name="Location" label="Location"><Input /></Form.Item>
              <Form.Item name="Contact" label="Contact"><Input /></Form.Item>
              <Form.Item name="Email" label="Email"><Input /></Form.Item>
            </Form>
          </Modal>
        </TabPane>
        <TabPane tab="Customers" key="customers">
          <div style={{ marginBottom: 16 }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                setCustomerModalVisible(true);
                setEditingCustomer(null);
                customerForm.resetFields();
              }}
            >
              Add Customer
            </Button>
            <Upload
              accept=".csv"
              showUploadList={false}
              customRequest={handleCustomerCSV}
              style={{ marginLeft: 8 }}
            >
              <Button icon={<UploadOutlined />} style={{ marginLeft: 8 }}>
                Import Customers CSV
              </Button>
            </Upload>
            <Button
                  type="default"
                  onClick={() => exportCSV(filteredCustomersList, "Customers")}
                  style={{ marginLeft: 8 }}
              >
                  Export Customers CSV
            </Button>

              <a
              href="/customers_sample.csv"
              download
              style={{ marginLeft: 16 }}
            >
              Download Sample CSV
            </a>
          </div>
              <Row gutter={8} style={{ marginBottom: 8 }}>
                <Col>
                    <Select
                        mode="multiple"
                        style={{ minWidth: 400 }}
                        allowClear
                        placeholder="Filter by Customer Name"
                        value={customerNameFilter}
                        onChange={setCustomerNameFilter}
                    >
                        {customerNameOptions.map(name => (
                            <Select.Option key={name} value={name}>{name}</Select.Option>
                        ))}
                    </Select>
                </Col>
                <Col>
                    <Select
                        mode="multiple"
                        allowClear
                        style={{ minWidth: 200 }}
                        placeholder="Filter by Location"
                        value={customerLocationFilter}
                        onChange={setCustomerLocationFilter}
                    >
                        {customerLocationOptions.map(loc => (
                            <Select.Option key={loc} value={loc}>{loc}</Select.Option>
                        ))}
                    </Select>
                </Col>

                <Col>
                    <Button onClick={() => { setCustomerLocationFilter([]);setCustomerNameFilter([]); }}>Reset</Button>
                </Col>
            </Row>



            <Table
            dataSource={filteredCustomers}
            columns={customerColumns}
            rowKey="CustomerID"
            scroll={{ x: 1000 }}
          />
          <Modal
            open={customerModalVisible}
            onCancel={() => {
              setCustomerModalVisible(false);
              setEditingCustomer(null);
              customerForm.resetFields();
            }}
            onOk={() => customerForm.submit()}
            title={editingCustomer ? "Edit Customer" : "Add Customer"}
            destroyOnClose
            width={800}
          >
            <Form form={customerForm} onFinish={onCustomerFinish} layout="vertical">
              <Form.Item name="CustomerName" label="Customer Name" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item name="CustomerAddress" label="Customer Address">
                <Input.TextArea rows={2} />
              </Form.Item>
              <Form.Item
                  name="GST"
                  label="GST"
                  rules={[
                    // { required: true, message: "GST is required." },
                    {
                      pattern: /^[A-Za-z0-9]{15}$/,
                      message: "GST must be exactly 15 alphanumeric characters (no special characters)."
                    }
                  ]}
              >
                <Input maxLength={15} />
              </Form.Item>
              <Form.Item
                  name="PAN"
                  label="PAN"
                  rules={[
                    //{ required: true, message: "PAN is required." },
                    {
                      pattern: /^[A-Za-z0-9]{10}$/,
                      message: "PAN must be exactly 10 alphanumeric characters (no special characters)."
                    }
                  ]}
              >
                <Input maxLength={10} />
              </Form.Item>
              <Form.Item
                  name="Location"
                  label="Location"
                  rules={[
                      { required: true, message: "Location is required." },
                      {
                          message: "Location is mandatory"
                      }
                  ]}
              >
                  <Input /></Form.Item>
              <Form.Item name="Contact" label="Contact"><Input /></Form.Item>
              <Form.Item name="Email" label="Email"><Input /></Form.Item>
            </Form>
          </Modal>
        </TabPane>

        <TabPane tab="PO" key="po">
          <div style={{ marginBottom: 16 }}>
            <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setPOModalVisible(true);
                  setEditingPO(null);
                  poForm.resetFields();
                }}
            >
              Add PO
            </Button>
            <Upload
                accept=".csv"
                showUploadList={false}
                customRequest={handlePOCSV}
                style={{ marginLeft: 8 }}
            >
              <Button icon={<UploadOutlined />} style={{ marginLeft: 8 }}>
                Import PO CSV
              </Button>
            </Upload>
            <Button
                  type="default"
                  onClick={() => exportCSV(filteredPO, "PO_Master")}
                  style={{ marginLeft: 8 }}
              >
                  Export PO CSV
            </Button>

              <a
                href="/po_sample.csv"
                download
                style={{ marginLeft: 16 }}
            >
              Download Sample PO CSV
            </a>
          </div>

            <Row gutter={8} style={{ marginBottom: 8 }}>
                <Col>
                    <Select
                        mode="multiple"
                        style={{ minWidth: 150 }}
                        allowClear
                        placeholder="Filter by PO Number"
                        value={poNumberFilter}
                        onChange={setPONumberFilter}
                    >
                        {poNumberOptions.map(loc => (
                            <Select.Option key={loc} value={loc}>{loc}</Select.Option>
                        ))}
                    </Select>
                </Col>
                <Col>
                    <Select
                        mode="multiple"
                        style={{ minWidth: 400 }}
                        allowClear
                        placeholder="Filter by Customer Name"
                        value={poCustomerNameFilter}
                        onChange={setPOCustomerNameFilter}
                    >
                        {poCustomerNameOptions.map(loc => (
                            <Select.Option key={loc} value={loc}>{loc}</Select.Option>
                        ))}
                    </Select>
                </Col>
                <Col>
                    <Select
                        mode="multiple"
                        style={{ minWidth: 200 }}
                        allowClear
                        placeholder="Filter by Location"
                        value={poLocationFilter}
                        onChange={setSPOLocationFilter}
                    >
                        {poLocationOptions.map(loc => (
                            <Select.Option key={loc} value={loc}>{loc}</Select.Option>
                        ))}
                    </Select>
                </Col>
                <Col>
                    <Button onClick={() => { setPONumberFilter([]);setCustomerNameFilter([]);setSPOLocationFilter([]); }}>Reset</Button>
                </Col>
            </Row>


            <Table
              dataSource={filteredPO}
              columns={poColumns}
              rowKey="POID"
              scroll={{ x: 600 }}
          />
          <Modal
              open={poModalVisible}
              onCancel={() => {
                setPOModalVisible(false);
                setEditingPO(null);
                poForm.resetFields();
              }}
              onOk={() => poForm.submit()}
              title={editingPO ? "Edit PO" : "Add PO"}
              destroyOnClose
              width={800}
          >
            <Form form={poForm} onFinish={onPOFinish} layout="vertical">
              <Form.Item name="PO_Number" label="PO Number" rules={[{ required: true }]}>
                <Input disabled={!!editingPO} />
              </Form.Item>
              <Form.Item name="PO_Date" label="PO Date" rules={[{ required: true }]}>
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item name="PO_Desc" label="PO Description">
                <Input.TextArea rows={2} />
              </Form.Item>
                <Form.Item
                    label="Customer"
                    name="CustomerID"
                    rules={[{ required: true, message: "Customer is required" }]}
                >
                    <Select
                        showSearch
                        placeholder="Select Customer"
                        filterOption={(input, option) => {
                            // This will correctly handle React nodes and concatenate child texts
                            const label = typeof option.children === 'string'
                                ? option.children
                                : (Array.isArray(option.children)
                                    ? option.children.join(' ')
                                    : String(option.children));
                            return label.toLowerCase().includes(input.toLowerCase());
                        }}
                    >
                        {customers.map(c => (
                            <Select.Option key={c.CustomerID} value={c.CustomerID}>
                                {c.CustomerName} - {c.Location}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                  name="PO_Amount"
                  label="PO Amount"
                  rules={[{ required: true, message: 'Please enter the PO Amount' }]}
              >
                <InputNumber
                    min={-Infinity}
                    step={0.01}
                    style={{ width: '100%' }}
                    stringMode // allows accurate decimal representation
                    onChange={onPOAmountChange}
                    placeholder="Enter PO Amount"
                    //disabled={!editingPO}
                />
              </Form.Item>
              {editingPO && (
              <Form.Item
                  name="PO_Remaining_Amount"
                  label="PO Remaining Amount"
                  rules={[{ required: true, message: 'Please enter the PO Remaining Amount' }]}
              >
                <InputNumber
                    min={0}
                    step={0.01}
                    style={{ width: '100%' }}
                    stringMode // allows accurate decimal representation
                    placeholder="Enter PO Remaining Amount"
                    disabled
                />
              </Form.Item>
                  )}
            </Form>
          </Modal>
        </TabPane>

          <TabPane tab="SAC Codes" key="saccode">
              <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => {
                      setSacModalVisible(true);
                      setEditingSac(null);
                      sacForm.resetFields();
                  }}
                  style={{ marginBottom: 16 }}
              >
                  Add SAC Code
              </Button>
              <Button
                  type="default"
                  onClick={() => exportCSV(sacCodes, "SAC_Code")}
                  style={{ marginLeft: 8 }}
              >
                  Export SAC Code CSV
              </Button>

              <Table
                  columns={sacColumns}
                  dataSource={Array.isArray(sacCodes) ? sacCodes : []}
                  rowKey="sacID"
                  pagination={{ pageSize: 10 }}
              />

              <Modal
                  visible={sacModalVisible}
                  title={editingSac ? "Edit SAC Code" : "Add SAC Code"}
                  onCancel={() => setSacModalVisible(false)}
                  onOk={() => sacForm.submit()}
                  destroyOnClose
                  width={800}
              >
                  <Form form={sacForm} onFinish={onSacFinish} layout="vertical">
                      <Form.Item
                          name="SAC_Code"
                          label="SAC Code"
                          rules={[{ required: true, message: "Please enter SAC Code" }]}
                      >
                          <Input />
                      </Form.Item>
                      <Form.Item
                          name="GST_Value"
                          label="GST Value (%)"
                          rules={[
                              { required: true, message: "Please enter GST Value" },
                              {
                                  type: "number",
                                  min: 0,
                                  max: 100,
                                  message: "GST Value must be between 0 and 100",
                                  transform: (value) => Number(value)
                              }
                          ]}
                      >
                          <InputNumber style={{ width: "100%" }} />
                      </Form.Item>
                  </Form>
              </Modal>
          </TabPane>

          <TabPane tab="Biller" key="biller">
              <Button
                  type="primary"
                  onClick={() => {
                      setBillerModalVisible(true);
                      setEditingBiller(null);
                      billerForm.resetFields();
                  }}
                  style={{ marginBottom: 16 }}
              >
                  Add Biller
              </Button>
              <Button
                  type="default"
                  onClick={() => exportCSV(billers, "Biller")}
                  style={{ marginLeft: 8 }}
              >
                  Export Biller CSV
              </Button>

              <Table columns={billerColumns} dataSource={billers} rowKey="id" pagination={{ pageSize: 10 }} />

              <Modal
                  visible={billerModalVisible}
                  title={editingBiller ? 'Edit Biller' : 'Add Biller'}
                  onCancel={() => setBillerModalVisible(false)}
                  onOk={() => billerForm.submit()}
                  destroyOnClose
                  width={800}
              >
                  <Form form={billerForm} onFinish={onBillerFinish} layout="vertical">
                      <Form.Item name="company_name" label="Company Name" rules={[{ required: true }]}>
                          <Input />
                      </Form.Item>
                      <Form.Item name="Address" label="Address" rules={[{ required: true }]}>
                          <Input.TextArea rows={2} />
                      </Form.Item>
                      <Form.Item name="account_holder" label="Account Holder" rules={[{ required: true }]}>
                          <Input />
                      </Form.Item>
                      <Form.Item name="bank_name" label="Bank Name">
                          <Input />
                      </Form.Item>
                      <Form.Item name="Vendor_code" label="Vendor Code">
                          <Input />
                      </Form.Item>
                      <Form.Item name="PAN" label="PAN">
                          <Input />
                      </Form.Item>
                      <Form.Item name="TAN" label="TAN">
                          <Input />
                      </Form.Item>
                      <Form.Item name="Account_number" label="Account Number">
                          <Input />
                      </Form.Item>
                      <Form.Item name="IFSC_code" label="IFSC Code">
                          <Input />
                      </Form.Item>
                      <Form.Item name="GST" label="GST Number">
                          <Input />
                      </Form.Item>
                      <Form.Item name="email" label="Email" rules={[{ type: 'email' }]}>
                          <Input />
                      </Form.Item>
                      <Form.Item name="Mobile" label="Mobile">
                          <Input />
                      </Form.Item>
                  </Form>
              </Modal>
          </TabPane>
          <TabPane tab="AdHoc List" key="adhoc-list">
              {/* Add/Edit buttons + CSV */}
              <div style={{ marginBottom: 16 }}>
                  <Space>
                      <Button
                          type="primary"
                          icon={<PlusOutlined />}
                          onClick={() => {
                              setAdhocModalVisible(true);
                              setEditingAdhoc(null);
                              adhocForm.resetFields();
                          }}
                      >
                          Add AdHoc Record
                      </Button>
                      <Button
                          type="default"
                          icon={<DownloadOutlined />}
                          onClick={() => downloadSampleCsv()}
                      >
                          Sample CSV
                      </Button>
                      <Upload {...adhocCsvUploadProps}>
                          <Button icon={<UploadOutlined />}>
                              Bulk Import CSV
                          </Button>
                      </Upload>
                      <Button
                          type="default"
                          icon={<DownloadOutlined />}
                          onClick={() => exportCSV(adhocs, "AdHoc")}
                      >
                          Export CSV
                      </Button>
                  </Space>
              </div>

              {/* Table */}
              <Table
                  columns={adhocColumns}
                  dataSource={adhocs}
                  rowKey="id"
                  pagination={{ pageSize: 10 }}
                  loading={adhocLoading}
              />

              {/* Add/Edit Modal */}
              <Modal
                  title={editingAdhoc ? 'Edit AdHoc Record' : 'Add AdHoc Record'}
                  open={adhocModalVisible}
                  onCancel={() => {
                      setAdhocModalVisible(false);
                      adhocForm.resetFields();
                      setEditingAdhoc(null);
                  }}
                  onOk={() => adhocForm.submit()}
                  destroyOnClose
                  width={600}
              >
                  <Form
                      form={adhocForm}
                      onFinish={onAdhocFinish}
                      layout="vertical"
                  >
                      <Form.Item name="Name" label="Name" rules={[{ required: true, message: 'Name is required' }]}>
                          <Input placeholder="Enter name" />
                      </Form.Item>
                      <Form.Item name="Message" label="Message">
                          <Input.TextArea rows={3} placeholder="Enter message" />
                      </Form.Item>
                      <Form.Item name="Amount" label="Amount">
                          <Input type="number" step="0.01" placeholder="Enter amount" />
                      </Form.Item>
                      <Form.Item name="Contact" label="Contact">
                          <Input placeholder="Enter contact number" />
                      </Form.Item>
                  </Form>
              </Modal>
          </TabPane>

      </Tabs>
    </Card>
  );
}

